import styled from 'styled-components';

import { Location } from 'features/location/Location';

import { Label } from 'components/Toolkit/Inputs/Label';

const Container = styled.div`
  margin-bottom: 20px;
`;

function LocationFilter() {
  return (
    <Container>
      <Label variant="COMFORT">Location</Label>
      <Location
        displayInline
        skeletonListLength={12}
        maxHeight="424px"
        maxTextContainerWidthWeb="228px"
      />
    </Container>
  );
}

export { LocationFilter };
